import React, { useState, useEffect, useRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { getPaymentProviderInfo } from './paymentProvider.util';
import AddCardIframeContainer from '../../payment-cards/AddCardIframeContainer';
import { PAYMENT_GATEWAY_SELECTOR } from '../../../components/myeirconstant/myEirConstant';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';
import Loading from '../../../components/loading/Loading';
import StancerAddCardContainer from '../stancer-payment-gateway/StancerAddCardContainer';

const { ELAVON } = PAYMENT_GATEWAY_SELECTOR;

/**
 * @name PaymentGatewaySelectorAddCard - Component to display add card
 * @param {*} props - React props
 * @returns {Component} - Return component based on provider either ELAVON or STANCER
 */
const PaymentGatewaySelectorAddCard = props => {
    const graphql = useApolloClient();
    const [provider, setProvider] = useState('');
    const [openError, setOpenError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPaymentProviderInfo({
            graphql,
            setProvider,
            setOpenError,
            setLoading,
        });
    }, []);

    return (
        <React.Fragment>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {provider === ELAVON ? (
                        <AddCardIframeContainer
                            handleBack={props.handleBack}
                            handleNext={props.handleNext}
                            setHeader={props.setHeader}
                            resetStep={props.resetStep}
                            toggle4={props.toggle}
                        />
                    ) : (
                        <StancerAddCardContainer
                            handleBack={props.handleBack}
                            handleNext={props.handleNext}
                            setHeader={props.setHeader}
                            resetStep={props.resetStep}
                            toggle4={props.toggle}
                        />
                    )}
                    {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
                </>
            )}
        </React.Fragment>
    );
};
export default PaymentGatewaySelectorAddCard;
